module.exports = __webpack_public_path__ + "static/img/aupaircare.08f023e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aupaircare.png
// module id = Vxac
// module chunks = 10